import useFetchService from '@/composables/useFetchService';

export default function useFavoriteService() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const runtimeConfig = useRuntimeConfig();
  const fetchService = useFetchService({ base: runtimeConfig.public.apiUrl });

  /********************
   * FUNCTIONS         *
   ********************/
  function getFavorites(lang: string, params: any) {
    return fetchService.get('/favorites/', lang, { params }, 2);
  }

  return {
    getFavorites,
  };
}
